import '@atlaskit/css-reset'
import { Box, Stack, xcss } from '@atlaskit/primitives'
import { Global, css } from '@emotion/react'
import React from 'react'
import fonts from '../fonts'
import analytics from '../services/analytics'
import Footer from './Footer'
import Header from './Header'

// taken from @atlaskit/theme
const akFontFamily = `-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif`

const layoutStyles = {
  wrapper: xcss({ minHeight: '100vh' }),
  main: xcss({
    backgroundColor: 'color.background.neutral',
    flexGrow: 1,
  }),
}

export default function Layout({ children }) {
  React.useEffect(() => {
    analytics.events.viewed()
  }, [])

  return (
    <>
      <Global
        styles={css`
          @font-face {
            font-family: 'Charlie Display';
            src: url(${fonts.CharlieDisplaySemiBold});
            font-weight: 500;
            font-display: swap;
          }

          @font-face {
            font-family: 'Charlie Display';
            src: url(${fonts.CharlieDisplayRegular});
            font-weight: 400;
            font-display: swap;
          }

          @font-face {
            font-family: 'Charlie Display';
            src: url(${fonts.CharlieDisplayThin});
            font-weight: 100;
            font-display: swap;
          }

          @font-face {
            font-family: 'Charlie Text';
            src: url(${fonts.CharlieTextRegular});
            font-weight: 400;
            font-display: swap;
          }

          h1,
          h2,
          h3,
          h4 {
            font-family: 'Charlie Display', ${akFontFamily};
          }

          h1 {
            font-size: 44px;
            line-height: 52px;
            font-weight: 500;
          }

          h2 {
            font-size: 35px;
            line-height: 40px;
            font-weight: 500;
          }

          h3 {
            font-size: 35px;
            line-height: 28px;
            letter-spacing: 0.3px;
          }

          h4 {
            font-size: 20px;
            line-height: 24px;
            font-weight: 600;
          }

          p,
          span {
            font-family: 'Charlie Text', ${akFontFamily};
          }

          p {
            font-size: 16px;
          }

          span {
            font-size: 14px;
          }

          @media screen and (max-width: 640px) {
            h1 {
              font-size: 29px;
              line-height: 40px;
            }

            h2,
            h3 {
              font-size: 24px;
              line-height: 32px;
            }

            h4 {
              font-size: 16px;
              line-height: 24px;
            }
          }
        `}
      />
      <Stack xcss={layoutStyles.wrapper}>
        <Header />
        <Box as='main' xcss={layoutStyles.main}>
          {children}
        </Box>
        <Footer />
      </Stack>
    </>
  )
}
